<template>
    <el-table :data="data" :default-sort="{ prop: ORDERS.orderStep.createdAt, order: 'ascending' }" class="w-100">
        <el-table-column :prop="ORDERS.orderStep.action" label="Action"> </el-table-column>
        <el-table-column :prop="ORDERS.orderStep.userId" label="User ID"> </el-table-column>
        <el-table-column :prop="ORDERS.orderStep.userType" label="User Type"> </el-table-column>
        <el-table-column :prop="ORDERS.orderStep.createdAt" label="Occurred" sortable>
            <template slot-scope="scope">
                {{ `${getCreatedDate(scope.row[ORDERS.orderStep.createdAt])}` }}
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import { ORDERS } from 'db'
export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            ORDERS
        }
    },
    methods: {
        getCreatedDate(date) {
            return new Date(date).toLocaleString('en-US', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.el-table table .btn {
    margin: 0 5px;
}
</style>
